// extracted by mini-css-extract-plugin
module.exports = {"contrastTitle":"ContrastTitle_contrastTitle__Btq8A"};